import clsx from 'clsx';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAppContext } from 'src/contexts/AppContext';
import { useLocalizationContext } from 'src/contexts/LocalizationContext';
import { Stack } from 'src/core/ui';
import {
  Listing,
  ListingDetailsAutoPricingSectionUpdates,
  Marketplace,
} from 'src/WebApiController';

import * as styles from './ListingDetailPanel.css';
import { PricingSettingAutoPriceListing } from './PricingSetting/PricingSettingAutoPriceListing';
import { PricingSettingHeader } from './PricingSetting/PricingSettingHeader';
import { PricingSettingManualPrice } from './PricingSetting/PricingSettingManualPrice';

export const ListingDetailListingHeader = ({
  selectedListing,
  useVerticalView,
  shouldDetailsSideBySide,
}: {
  selectedListing: Listing;
  useVerticalView: boolean;
  shouldDetailsSideBySide: boolean;
}) => {
  const { loginContext } = useAppContext();
  const { getUiCurrency } = useLocalizationContext();
  const stubHubMkpSettings =
    loginContext?.user?.activeAccount?.marketplaceSettings?.find(
      (m) => m.mkp === Marketplace.StubHub
    );

  const uiCurrency = useMemo(
    () =>
      getUiCurrency(
        selectedListing?.currency ??
          loginContext?.user?.activeAccount?.currencyCode
      ),
    [
      getUiCurrency,
      selectedListing?.currency,
      loginContext?.user?.activeAccount?.currencyCode,
    ]
  );

  const { watch } = useFormContext<ListingDetailsAutoPricingSectionUpdates>();
  const { autoPricingEnabled } = watch();

  return (
    <div
      className={clsx(styles.pricingSettingsContainerBase, {
        [styles.pricingSettingsContainerBaseRow]: shouldDetailsSideBySide,
      })}
    >
      <Stack width="full" gap="s" direction="column">
        <div className={styles.pricingSettingsHeader}>
          <PricingSettingHeader listing={selectedListing} />
        </div>

        <div className={styles.pricingSettingsBody}>
          {autoPricingEnabled ? (
            <PricingSettingAutoPriceListing
              uiCurrency={uiCurrency}
              sellerFee={stubHubMkpSettings?.sellerFee ?? null}
              useVerticalView={useVerticalView}
            />
          ) : (
            <PricingSettingManualPrice
              uiCurrency={uiCurrency}
              sellerFee={stubHubMkpSettings?.sellerFee ?? null}
            />
          )}
        </div>
      </Stack>
    </div>
  );
};
